import { gql } from 'apollo-angular'

export const GET_SUBSCRIPTIONS = gql`
  query Subscriptions($currentDate: DateTime!, $where: Subscription_where_and) {
    Subscriptions(
      select: true
      where: {
        AND: [
          {
            OR: [
              { endDate: { equals: null } }
              { endDate: { greater_than_equal: $currentDate } }
            ]
          }
          $where
        ]
      }
    ) {
      docs {
        id
        name
        isPaid
        product {
          id
          name
          magazine {
            id
            title
            archived
            media {
              cover {
                url
              }
            }
          }
        }
        scheduledChange {
          docs {
            id
            scheduled_for
            product_options {
              id
              quantity
              product_option {
                id
                name
                type
                from_seats
                seat_value
                invoicing {
                  price
                  currency
                  frequency
                  tax_rate
                }
              }
              discount
              discount_percentage
              custom_price
            }
          }
        }
        product_options {
          id
          quantity
          product_option {
            id
            name
            type
            from_seats
            seat_value
          }
        }
        totalSeats
        activeSeatAllocations
        startDate
        billingCycle {
          frequency
          startDate
          nextInvoicingDate
        }
        endDate
        reference
        organization {
          id
          name
        }
      }
    }
  }
`
